import { useEffect, useState } from "react"

import { useWindowSize } from "@trueskin-web/components/src/styleguide/skinui/utils/use-window-size"

const getTextStyles = (element) => {
  if (!element) {
    return {}
  }

  const computedStyles = getComputedStyle(element)

  return {
    fontSize: computedStyles.getPropertyValue("font-size"),
    lineHeight: computedStyles.getPropertyValue("line-height"),
    letterSpacing: computedStyles.getPropertyValue("letter-spacing"),
  }
}

const useFontStyles = (textElement) => {
  const windowSize = useWindowSize()
  const [styles, setStyles] = useState(getTextStyles(textElement))

  useEffect(() => {
    if (textElement && windowSize?.height && windowSize?.width) {
      setStyles(getTextStyles(textElement))
    }
  }, [textElement, windowSize])

  return styles
}

export { useFontStyles }
